@if (relatedArticles1.length === 0 && relatedArticles2.length === 0 && relatedArticles3.length === 0) {
<ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
@if (relatedArticles1.length > 0) {
<h3>Related articles</h3>
<div>
  @if (relatedArticles1.length > 0) {
  <span>
    @for (item of relatedArticles1; track item; let i = $index) {
    <app-link [to]="item.path">{{ item.title }}</app-link>
    }
  </span>
  } @if (relatedArticles2.length > 0) {
  <span>
    @for (item of relatedArticles2; track item; let i = $index) {
    <app-link [to]="item.path">{{ item.title }}</app-link>
    }
  </span>
  } @if (relatedArticles3.length > 0) {
  <span>
    @for (item of relatedArticles3; track item; let i = $index) {
    <app-link [to]="item.path">{{ item.title }}</app-link>
    }
  </span>
  }
</div>
}
